import { EChatActionTypes } from '../../actions/chat';
import { IAppState, IChatState, TActions } from '../../common/state';

export const defaultState: IChatState = {
  offer: null,
  isOpened: false,
  position: null,
};

export function chatReducer(state: IAppState, action: TActions): IAppState {
  switch (action.type) {
    case EChatActionTypes.Open: {
      return {
        ...state,
        chat: {
          offer: action.payload.offer,
          isOpened: true,
          position: action.payload.position,
        },
      };
    }
    case EChatActionTypes.Close: {
      return {
        ...state,
        chat: defaultState,
      };
    }
  }

  return state;
}
